



















































































































































import BaseComponent from '@/components/base-component.vue';
import UiFileUpload from '@/components/UI/file-upload.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import { errorHandling } from '@/helpers/errorHandling';
import { IdNomeDTO } from '@/interfaces/base-dto';
import { UnidadeParmDTO } from '@/interfaces/clientUnit';
import ClientUnitModel from '@/models/client-unit-model';
import * as service from '@/services/client-unit';
import {
  ERROR_CODE_FILE_SIZE_EXCEEDED
} from '@/settings/consts/api-error';
import { IMAGE_MIME_TYPES } from '@/settings/consts/file-upload';
import {
  MESSAGE_FILE_ERROR_DELETE, MESSAGE_FILE_ERROR_UPLOAD,
  MESSAGE_FILE_SIZE_EXCEEDED
} from '@/settings/consts/messages';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ClientUnitTab from './client-unit-tabs.vue';

@Component({
  components: {
    PermissionAuth,
    ClientUnitTab,
    UiSelectClients,
    UiFileUpload,
  },
})
export default class ClientUnitForm extends BaseComponent {
  @Prop()
  public isEdit: boolean = false;
  @Prop()
  public editItem: any;

  public maxFileSize: number = 2000;
  public validTypes: string[] = IMAGE_MIME_TYPES;
  public file: any = null;
  public deleteFile: boolean = false;

  private viasFaturamento: IdNomeDTO[] = [];
  private tiposAgendamentosProd: any[] = [];

  public form: any = {
    valid: false,
    rules: {
      cnpj: [(v) => !!v || 'Digite o CNPJ'],
      name: [(v) => !!v || 'Digite o Nome'],
      horario: [(v) => (v && v.length == 5) || 'Informe o horário de envio para produção'],      
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  private validate() {
    this.$refs.form.validate();
  }

  public item: ClientUnitModel = new ClientUnitModel();

  mounted() {
    this.addSubsc(service.getBillingVias().subscribe(res => {
      this.viasFaturamento = res;
    }));
    this.addSubsc(service.getScheduleProductionTypes().subscribe(res => {
      this.tiposAgendamentosProd = res;
    }));
  }

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = new ClientUnitModel(val);
    this.item.produtos = this.item.produtos.map((item) => {
      return {
        id: item.id,
        descricaofull: item.codigo + ' - ' + item.descricao,
        codigo: item.codigo,
        descricao: item.descricao,
        subgrupo: item.subgrupo.nome,
        grupo: item.subgrupo.grupo.nome
      };
    });
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');
    let item = new UnidadeParmDTO(this.item);
    
    service.updateClientUnit(item).subscribe(
      (data) => {
        if (this.file) {
          this.salvarImagem(data);
        } else if (this.deleteFile) {
          this.excluirImagem(data);
        } else {
          this.callbackSaveSuccess(data);
        }
      },
      (error) => {
        this.tratarErro(error);
      },
    );
  }

  private tratarErro(error) {
    this.loader.stop();
    if (error.status == 406) {
      this.toast.show(error.data.message.replace(/\n/g, '</br>'), 'error', true, 8000);
    } else {
      this.toast.show('Ocorreu um erro ao atualizar a unidade', 'error');
    }
  }

  private callbackSaveSuccess(item) {
    this.loader.stop();
    this.$emit('save', item);
    this.$refs.form.resetValidation();
  }

  public salvarImagem(data): void {
    service.saveClientUnitImage(data.id, { file: this.file }).subscribe(
      (result) => {
        this.callbackSaveSuccess(data);
      },
      (error) => {
        this.onErrorFile(error, data);
      },
    );
  }

  public excluirImagem(data): void {
    service.deleteClientUnitImage(data.id).subscribe(
      (result) => {
        this.callbackSaveSuccess(data);
      },
      (error) => {
        this.onErrorDeleteFile(error, data);
      },
    );
  }

  onErrorFile = (error, data) => {
    this.loader.stop();
    this.item = new ClientUnitModel(data);

    const errorMessages = {
      default: MESSAGE_FILE_ERROR_UPLOAD,
    };

    let message;
    if (!!error && error.status === ERROR_CODE_FILE_SIZE_EXCEEDED) {
      message = !!error.data ? error.data : MESSAGE_FILE_SIZE_EXCEEDED;
    } else {
      message = errorHandling(error, errorMessages);
    }

    this.toast.show(message, 'error');
  };

  onErrorDeleteFile = (error, data) => {
    this.loader.stop();
    this.item = new ClientUnitModel(data);

    const errorMessages = {
      default: MESSAGE_FILE_ERROR_DELETE,
    };
    const message = errorHandling(error, errorMessages);
    this.toast.show(message, 'error');
  };

  public onRemoveFile() {
    this.deleteFile = true;
    this.item.imagem = null;
    this.file = null;
  }

  public closeForm(): void {
    const closeAction = () => {
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }
}
